import merge from "lodash/merge";
import {useDispatch, useSelector} from "react-redux";
import ScrollBar from "react-perfect-scrollbar";
import clsx from "clsx";

import {setLayoutSettings} from "app/redux/layout/layoutSlice";
import {FaBell, FaClipboardList, FaFileAlt, FaHistory, FaLightbulb, FaPhoneAlt, FaWhatsapp} from 'react-icons/fa';
import React, {useState} from "react";
import Sidebar from "../../views/ia-chat/Sidebar";

export default function Customizer() {
    const dispatch = useDispatch();
    const {settings} = useSelector((state) => state.layout);
    let {activeLayout} = settings;

    const sidebarColors = [
        {name: "gradient-purple-indigo"},
        {name: "gradient-black-blue"},
        {name: "gradient-black-gray"},
        {name: "gradient-steel-gray"},
        {name: "dark-purple"},
        {name: "slate-gray"},
        {name: "midnight-blue"},
        {name: "blue"},
        {name: "indigo"},
        {name: "pink"},
        {name: "red"},
        {name: "purple"}
    ];

    const handleLayoutChange = (layoutName) => {
        const merged = merge({}, settings, {activeLayout: layoutName});
        dispatch(setLayoutSettings(merged));
    };

    const handleCustomizerToggle = () => {
        const merged = merge({}, settings, {customizer: {open: !settings.customizer.open}});
        dispatch(setLayoutSettings(merged));
    };

    const handleDirectionChange = () => {
        let dir = settings.dir === "rtl" ? "ltr" : "rtl";
        document.documentElement.setAttribute("dir", dir);

        dispatch(setLayoutSettings(merge({}, settings, {dir: dir})));
    };

    const changeSidebarColor = (colorClass) => {
        const merged = merge({}, settings, {layout2Settings: {leftSidebar: {theme: colorClass}}});
        dispatch(setLayoutSettings(merged));
    };

    const [activeAction, setActiveAction] = useState()

    const recentChats = [
        {
            title: "Cobrança via WhatsApp",
            type: 'whats',
            description: "Acompanhamento da resposta de João da Silva sobre a cobrança do boleto vencido.",
            lastModify: '10 Min'
        },
        {
            title: "Análise de Ligações",
            type: 'callAnalitics',
            description: "Relatório de emoções detectadas na chamada com Maria Santos sobre negociação de dívida.",
            lastModify: '2 Horas'
        },
        {
            title: "Status de Processamento",
            type: 'callTranscribe',
            description: "Seu pedido de transcrição de chamadas do dia 25/01 foi finalizado.",
            lastModify: '3h 30 Min'
        },
        {
            title: "Sugestões de Melhoria",
            type: 'offerInsights',
            description: "Recomendações de abordagem com clientes para melhorar taxa de conversão.",
            lastModify: '2 Dias'
        },
        {
            title: "Geração de Relatórios",
            type: 'report',
            description: "Resumo da inadimplência da carteira de clientes foi gerado."
        },
        {
            title: "Análise de Contratos",
            type: 'contracts',
            description: "Identificação de cláusulas críticas no contrato de prestação de serviço de XYZ Ltda.",
            lastModify: '2 Dias'
        },
        {
            title: "Alertas e Pendências",
            type: 'alerts',
            description: "Clientes com maior risco de inadimplência foram identificados.",
            lastModify: '2 Dias'
        },
    ];

    const eventIcons = {
        whats: <FaWhatsapp className="text-success"/>,
        callAnalitics: <FaPhoneAlt className="text-primary"/>,
        callTranscribe: <FaClipboardList className="text-warning"/>,
        offerInsights: <FaLightbulb className="text-info"/>,
        report: <FaClipboardList className="text-secondary"/>,
        contracts: <FaFileAlt className="text-dark"/>,
        alerts: <FaBell className="text-danger"/>,
    };

    return (
        <div id="customizer" className={clsx({customizer: true, open: settings.customizer.open})}>
            <div className="handle" onClick={handleCustomizerToggle}>
                <FaHistory/>
            </div>

            <ScrollBar className="customizer-body" data-perfect-scrollbar data-suppress-scroll-x="true">
                <div >
                    <div className="card">
                        <div>
                            <div className="card-header">
                                <p className="mb-0">Histórico de Chats</p>
                            </div>

                            <div className="card-body">
                              <Sidebar recentChats={recentChats} onNewChat={() => setActiveAction(null)} />
                            </div>

                        </div>
                    </div>
                </div>
            </ScrollBar>
        </div>
    );
}
